let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iXgVz")).then(() => parcelRequire('72QiW'));